import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/WhiteButton.module.scss'

import { Button } from 'react-bootstrap'

class WhiteButton extends React.Component {

  render() {

    const { text, width, svg, onClick, className } = this.props

    return (
      <Button
        className={className != `` ? `${styles.button} ${className}` : styles.button}
        as={`div`}
        variant='light'
        style={{ width: `${width}px` }}
        onClick={() => onClick()}
      >
        <div className={styles.button_icon}>{svg}</div>
        <div className={styles.button_text}>{text}</div>
      </Button>
    )
  }
}

WhiteButton.propTypes = {
  text: PropTypes.string,
  width: PropTypes.number,
  svg: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string
}

WhiteButton.defaultProps = {
  text: `Смотреть видео`,
  width: 145,
  svg: (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.25 5.06738C8.5831 5.25987 8.5831 5.74013 8.25 5.93262L1.5 9.83008C1.16677 10.0225 0.750249 9.78216 0.75 9.39746L0.75 1.60254C0.75025 1.21784 1.16677 0.977529 1.5 1.16992L8.25 5.06738Z" stroke="white"/>
    </svg>
  ),
  onClick: () => {
    window.console.log( `btn click` )
  },
  className: ``
}

export default WhiteButton